import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { RenderInput } from './Base';
import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog } from '@blueprintjs/core';

import { saveDonor } from '../../../../redux/actions/donor.actions';

const mapStateToProps = (state) => ({
    donor: state.donor
});

class AddDonorModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            first_name: '',
            middle_name: '',
            last_name: '',
            gender: 'M',
            phone: '',
            email: '',
            street_address: '',
            country_of_residence: '',
            city_of_residence: '',
            state_or_province: '',
            postal_code: '',
            local_church: '',
            mef_signup_date: new Date(),
            notes: ''
        };
        this.state = {
            showModal: false,
            form: this.emptyForm
        };
    }
    componentDidMount() {
        window.addEventListener('open-add-donor-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-add-donor-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { donor: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;
        this.setState({
            showModal: true,
            form: detail ? detail : {...this.emptyForm}
        });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, value }) => {
        const { form } = this.state;
        form[value] = text;
        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.saveDonor();
        }
    }
    saveDonor = () => {
        const { form } = this.state;
        const { saveDonor } = this.props;
        saveDonor({
            ...form,
            mef_signup_date: moment(form['mef_signup_date'])
        });
    }
    render() {
        const { showModal, form } = this.state;
        const { saveLoading } = this.props.donor;
        return (
            <Dialog icon='person'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                title="Save Donor">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="First Name"
                                    name="first_name"
                                    value={form.first_name}
                                    autoFocus
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Middle Name"
                                    name="middle_name"
                                    value={form.middle_name}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Last Name"
                                    name="last_name"
                                    value={form.last_name}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <div className="flex-column">
                                    <label className="pt-label">
                                        Gender
                                        <div className="pt-select">
                                            <select value={this.state.form.gender.toUpperCase()}
                                                onChange={event => this.onChangeHandler({ text: event.target.value, value: 'gender' })}>
                                                <option value="F">F</option>
                                                <option value="M">M</option>
                                            </select>
                                        </div>
                                    </label>
                                </div>
                                <RenderInput label="MEF Sign Up Date"
                                    name="mef_signup_date"
                                    value={form.mef_signup_date}
                                    datePicker
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="E-mail"
                                    name="email"
                                    value={form.email}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Phone"
                                    name="phone"
                                    value={form.phone}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Country of Residence"
                                    name="country_of_residence"
                                    value={form.country_of_residence}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="State or Province"
                                    name="state_or_province"
                                    value={form.state_or_province}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="City of Residence"
                                    name="city_of_residence"
                                    value={form.city_of_residence}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Street Address"
                                    name="street_address"
                                    value={form.street_address}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Postal Code"
                                    name="postal_code"
                                    value={form.postal_code}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Local Church"
                                    name="local_church"
                                    value={form.local_church}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Notes"
                                    name="notes"
                                    value={form.notes}
                                    type="textarea"
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton
                                    className="pt-button pt-fill pt-intent-primary pt-large"
                                    text="Save Donor"
                                    onClick={this.saveDonor}
                                    isLoading={saveLoading}
                                />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,
    { saveDonor }
)(AddDonorModal);
                          


// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/DonorModal.jsx